<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text, Alert, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../../helpers/utilities';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let actions = [];
	export let active_actions = []; // because it is only one action we can be sure that active_actions contains only one element
	export let sceneIsValid; // Do not remove this line, it is used in the parent component and its validation

	const dispatch = createEventDispatcher();

	const mappedActionIcons = {
		0: 'fas fa-power-off text-success',
		1: 'fas fa-power-off text-danger',
		2: 'fal fa-toggle-on',
	};

	$: title = actions[0]?.title || 'Unknown element';
	$: values = actions[0]?.values || [];
	let activeAddOn = active_actions[0]?.addOnInd || undefined;

	$: active = active_actions[0]?.value || undefined;
	$: alert = actions[0]?.alert || undefined;
	//addOns is an object that returns key:values addOn objects
	//addOns is not an array, it's an object
	//the returned addOn object is an array with one object - its properties
	$: addOns = actions[0]?.addOns;

	$: addOnsSelectOptions =
		typeof addOns !== 'undefined'
			? addOns.map((option) => {
					return {
						title: option.name,
						value: option.add_on_ind,
					};
				})
			: [];

	$: selectList = [
		...actions[0]?.values.map((el, i) => {
			return {
				id: el,
				title: el,
			};
		}),
	];

	function getActiveAddOn() {
		let addOnInit = {
			title: '',
			value: undefined,
		};

		if (
			actions[0]?.addOns?.length > 0 &&
			actions[0]?.addOns !== undefined &&
			activeAddOn !== undefined
		) {
			let addOnObj = actions[0]?.addOns.find((e) => {
				return e.add_on_ind === activeAddOn;
			});

			addOnInit = {
				title: addOnObj.name,
				value: addOnObj.add_on_ind,
			};
		}

		return addOnInit;
	}

	let selectedAddOn = getActiveAddOn();

	function handleSelectAddOn(e) {
		selectedAddOn = e.detail;
	}

	$: val = selectList?.find((el) => el.id === active)?.id || undefined;

	const handle_radio_choice = (new_val) => {
		val = new_val;
		active_actions[0] = {
			name: actions[0].id,
			value: val,
			addOnInd: selectedAddOn.value,
		};
		dispatch('change_active', { new_active: [...active_actions] });
	};

	const _prepare_props_by_id = (id, _val) => {
		switch (id) {
			case 'turn':
				return $format('scene_action_turn_state', {
					values: { turn_state: $format(`label_action_turn_${_val}`) },
				});
			case 'turn_add_on':
				return $format('scene_action_turn_add_on_state', {
					values: { turn_state: $format(`label_action_turn_${_val}`) },
				});

			default:
				return {};
		}
	};
</script>

{#if addOns !== undefined}
	{#if addOns.length === 0}
		<Alert class="mb-s" message={alert} type={'warning'} />
	{:else}
		<!-- TODO Alex to pick the appropriate title -->
		<Text element="h2" class="mb-s">{capFirstChar($format(title))}</Text>
		<CardGrid sm={200} md={200} xl={200} noPaddingBottom>
			{#each addOnsSelectOptions as option}
				<div class="d-flex">
					<SelectCard
						cardBgColor={$showNewLayout ? 'color-1' : undefined}
						class="width-full"
						type="horizontal"
						variant="radio"
						title={option.title}
						selected={selectedAddOn.value === option.value}
						on:click={() => {
							console.log('ACTIVE', active, option, active_actions);
							handleSelectAddOn({ detail: option });
						}}
					/>
				</div>
			{/each}
		</CardGrid>

		{#if selectedAddOn.value}
			<!-- TODO Alex to pick the appropriate title -->
			<Text element="h2" class="mb-s mt-l"
				>{capFirstChar($format('title_select_state', { default: 'Select state' }))}</Text
			>
			{#if values.length > 0}
				{#if actions[0].alert}
					<Alert class="mb-s" message={actions[0].alert} type={'warning'} />
				{/if}

				<CardGrid sm={200} md={200} xl={200} noPaddingBottom>
					{#each selectList as _val, i}
						<div class="d-flex">
							<SelectCard
								cardBgColor={$showNewLayout ? 'color-1' : undefined}
								class="width-full"
								type="horizontal"
								variant="radio"
								title={`${_prepare_props_by_id(actions[0].id, _val.id)}`}
								icon={mappedActionIcons[i]}
								selected={val === _val.id}
								on:click={() => {
									handle_radio_choice(_val.id);
								}}
							/>
						</div>
					{/each}
				</CardGrid>
			{/if}
		{/if}
	{/if}
{:else}
	<Text element="h2" class="mb-s">{capFirstChar($format(title))}</Text>
	{#if values.length > 0}
		{#if actions[0].alert}
			<Alert class="mb-s" message={actions[0].alert} type={'warning'} />
		{/if}
		<CardGrid sm={200} md={200} xl={200} noPaddingBottom>
			{#each selectList as _val, i}
				<div class="d-flex">
					<SelectCard
						cardBgColor={$showNewLayout ? 'color-1' : undefined}
						class="width-full"
						type="horizontal"
						variant="radio"
						title={`${_prepare_props_by_id(actions[0].id, _val.id)}`}
						icon={mappedActionIcons[i]}
						selected={val === _val.id}
						on:click={() => {
							handle_radio_choice(_val.id);
						}}
					/>
				</div>
			{/each}
		</CardGrid>
	{/if}
{/if}
